import React, {useCallback, useState} from 'react'
import Calendar from 'react-calendar'
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import i18n from "i18next";
import './CalendarOverride.less'
import {ChevronLeft} from "@UI/components/icons/ChevronLeft.tsx";
import {ChevronRight} from "@UI/components/icons/ChevronRight.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {ColorNames} from "@UI/theme/generated/ColorNames.ts";
import styles from "./calendar.module.less";
import {useNavigate, useSearchParams} from "react-router-dom";
import {formatDate} from "@src/utils/formatDate.ts";

interface Props {
    initialStartDate?: Date
    initialEndDate?: Date
    isLoading?: boolean
}

type Value = [Date, Date]

export const FilterCalendar: React.FC<Props> = (
    {
        initialStartDate = new Date(),
        initialEndDate = new Date(),
        isLoading
    }) => {
    const [value, setValue] = useState<Value>([initialStartDate, initialEndDate])
    const navigate = useNavigate()
    const [params] = useSearchParams()

    const setFilter = useCallback(() => {
        if (!value) return
        const p = new URLSearchParams(params)
        if (p.get("date_range_after")) p.delete("date_range_after")
        if (p.get("date_range_before")) p.delete("date_range_before")
        p.set("date_range_after", formatDate(value[0].toISOString()))
        p.set("date_range_before", formatDate(value[1].toISOString()))

        if (p.get("record_range_after")) p.delete("record_range_after")
        if (p.get("record_range_before")) p.delete("record_range_before")
        p.set("record_range_after", formatDate(value[0].toISOString()))
        p.set("record_range_before", formatDate(value[1].toISOString()))
        navigate(`?${p.toString()}`, {replace: true})
    }, [value])

    return (
        <Stack justifyContent={"center"} direction={"column"} className={styles.root} gap={16}>
            <Stack justifyContent={"center"} direction={"column"} className={styles.calendar} gap={16}>
                <Calendar
                    calendarType={"gregory"}
                    locale={i18n.language}
                    prevLabel={<ChevronLeft/>}
                    prev2Label={null}
                    next2Label={null}
                    formatDay={(_, d) => d.getDate().toString()}
                    nextLabel={<ChevronRight/>}
                    selectRange
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    onChange={setValue}
                    value={value}
                />
                <Button type={ButtonType.secondary} color={ColorNames.CORAL_SUN} onClick={setFilter} style={{width: "100%"}} disabled={isLoading}>
                    <Gt>Narrow down</Gt>
                </Button>
            </Stack>
        </Stack>
    )
}